/* eslint-disable no-shadow */
import classNames from 'classnames'
import React from 'react'
import image from '../../image/empty_image.png'
import item from '../../image/empty_item.png'
import tag from '../../image/empty_tag.png'
import analysis from '../../image/empty_analysis.png'
import list from '../../image/empty_list.png'
import ins from '../../image/empty_ins.png'
import audit from '../../image/empty/empty_audit.png'
import task from '../../image/empty/empty_task.png'
import folder from '../../image/empty/empty_folder.png'
import msg from '../../image/empty/empty_msg.png'
import './index.less'

const TYPE = { image, item, tag, analysis, list, ins, audit, task, folder, msg }
const TEXT = { image: '图片', item: '商品', tag: '标签', analysis: '数据', list: '榜单', ins: 'ins', audit: 'audit', task: 'task', folder: 'folder', msg: 'msg' }
export default (props) => {
  const { className, style, image, title, subTitle, type = 'image', loading, noPadding, children } = props
  if (loading) return <div className="meinian-empty-space" />
  return <>
    {children && <div className="empty-exit">{children}</div>}
    <div className={classNames('meinian-empty', className, { 'no-padding': noPadding })} style={style}>
      <img className="empty-image" src={image || TYPE[type]} alt="" />
      <div className="empty-title">{title || `暂无相关${TEXT[type]}`}</div>
      <div className="empty-sub-title">{subTitle || ''}</div>
    </div>
  </>
}
